import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { IDeleteTimeAssignmentResponse } from "./types";

export const deleteTimeAssignment = async (assignmentId: string): Promise<IDeleteTimeAssignmentResponse> => {
  try {
    const response = await apiClientSource.delete(`/task-service/api/tasks-schedule/${assignmentId}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al eliminar la asignación de tiempo");
    throw error;
  }
};
